import React from 'react';

import Modal from '../Modal/Modal';
import styles from './JoinBackcellModal.module.scss';
import Button from '../Button/Button';

const JoinBackcellModal = ({
  active = false,
  setActive = () => null,
  join,
  ...restProps
}) => {
  return (
    <Modal
      {...restProps}
      active={active}
      setActive={setActive}
      className={styles.modal}
      itemScope
      itemType='https://schema.org/Offer'
    >
      <div
        className={'title'}
        dangerouslySetInnerHTML={{ __html: join?.title }}
      />
      <div className={styles.text}>{join?.description}</div>
      <div className={styles.form}>
        {join?.buttons?.length > 0 &&
          join.buttons.map((el) => (
            <Button
              key={el?.id}
              Component={!el?.external_link ? 'router' : 'a'}
              onClick={() => setActive(false)}
              href={!el?.external_link ? el?.slug : el.external_link}
              variant={'outline'}
              hasTarget={el.external_link && true}
            >
              {el?.text}
            </Button>
          ))}
      </div>
    </Modal>
  );
};

export default JoinBackcellModal;
